import { fromJS } from "immutable"

import {
  GET_TEMPLATE_SEGMENTS_COLLABORATORS_WATCHER,
  GET_TEMPLATE_SEGMENTS_COLLABORATORS_SUCCESS,
  GET_TEMPLATE_SEGMENTS_COLLABORATORS_FAILED,
  UPLOAD_TEMPLATE_SEGMENTS_COLLABORATORS_WATCHER,
  UPLOAD_TEMPLATE_SEGMENTS_COLLABORATORS_SUCCESS,
  UPLOAD_TEMPLATE_SEGMENTS_COLLABORATORS_FAILED,
  CLEAR_IMPORT_UPLOAD,
  CREATE_SEGMENT_FAILED,
  CREATE_SEGMENT_SUCCESS,
  CREATE_SEGMENT_WATCHER,
  DELETE_SEGMENT_WATCHER,
  DELETE_SEGMENT_FAILED,
  DELETE_SEGMENT_SUCCESS,
  GET_GROUPS_FAILED,
  GET_GROUPS_SUCCESS,
  GET_GROUPS_WATCHER,
  GET_SEGMENTS_FAILED,
  GET_SEGMENTS_SUCCESS,
  GET_SEGMENTS_WATCHER,
  GET_VARIABLES_FAILED,
  GET_VARIABLES_SUCCESS,
  GET_VARIABLES_WATCHER,
  UPDATE_SEGMENT_WATCHER,
  UPDATE_SEGMENT_SUCCESS,
  UPDATE_SEGMENT_FAILED,
} from "./constants"

export const initialState = fromJS({
  variables: [],
  isLoadingVariables: undefined,
  groups: [],
  isLoadingGroups: undefined,
  isLoadingCreateSegment: undefined,
  isErrorCreateSegment: false,
  isLoadingDeleteSegment: undefined,
  isErrorDeleteSegment: false,
  isLoadingUpdateSegment: undefined,
  isErrorUpdateSegment: false,
  segments: [],
  isLoadingSegments: undefined,
  importUpload: undefined,
  isDownloading: false,
})

function segmentsReducer(state = initialState, action) {
  switch (action.type) {
    case GET_TEMPLATE_SEGMENTS_COLLABORATORS_WATCHER:
      return state.set("isDownloading", true)
    case GET_TEMPLATE_SEGMENTS_COLLABORATORS_SUCCESS:
      return state.set("isDownloading", false)
    case GET_TEMPLATE_SEGMENTS_COLLABORATORS_FAILED:
      return state.set("isDownloading", false)
    case UPLOAD_TEMPLATE_SEGMENTS_COLLABORATORS_WATCHER:
      return state.set("isUploading", true)
    case UPLOAD_TEMPLATE_SEGMENTS_COLLABORATORS_SUCCESS:
      return state.set("importUpload", action.payload).set("isUploading", false)
    case UPLOAD_TEMPLATE_SEGMENTS_COLLABORATORS_FAILED:
      return state.set("isUploading", false)
    case CLEAR_IMPORT_UPLOAD:
      return state.set("importUpload", undefined)
    case GET_VARIABLES_WATCHER:
      return state.set("variables", []).set("isLoadingVariables", true)
    case GET_VARIABLES_SUCCESS:
      return state
        .set("variables", action.payload)
        .set("isLoadingVariables", false)
    case GET_VARIABLES_FAILED:
      return state.set("variables", []).set("isLoadingVariables", false)
    case GET_GROUPS_WATCHER:
      return state.set("groups", []).set("isLoadingGroups", true)
    case GET_GROUPS_SUCCESS:
      return state.set("groups", action.payload).set("isLoadingGroups", false)
    case GET_GROUPS_FAILED:
      return state.set("groups", []).set("isLoadingGroups", false)
    case CREATE_SEGMENT_WATCHER:
      return state.set("isLoadingCreateSegment", true)
    case CREATE_SEGMENT_SUCCESS:
      return state
        .set("isLoadingCreateSegment", false)
        .set("isErrorCreateSegment", false)
    case CREATE_SEGMENT_FAILED:
      return state
        .set("isLoadingCreateSegment", undefined)
        .set("isErrorCreateSegment", true)
    case UPDATE_SEGMENT_WATCHER:
      return state.set("isLoadingUpdateSegment", true)
    case UPDATE_SEGMENT_SUCCESS:
      return state
        .set("isLoadingUpdateSegment", false)
        .set("isErrorUpdateSegment", false)
    case UPDATE_SEGMENT_FAILED:
      return state
        .set("isLoadingUpdateSegment", undefined)
        .set("isErrorUpdateSegment", true)
    case DELETE_SEGMENT_WATCHER:
      return state.set("isLoadingDeleteSegment", true)
    case DELETE_SEGMENT_SUCCESS:
      return state
        .set("isLoadingDeleteSegment", false)
        .set("isErrorDeleteSegment", false)
    case DELETE_SEGMENT_FAILED:
      return state
        .set("isLoadingDeleteSegment", undefined)
        .set("isErrorDeleteSegment", true)
    case GET_SEGMENTS_WATCHER:
      return state.set("segments", []).set("isLoadingSegments", true)
    case GET_SEGMENTS_SUCCESS:
      return state
        .set("segments", action.payload)
        .set("isLoadingSegments", false)
    case GET_SEGMENTS_FAILED:
      return state.set("segments", []).set("isLoadingSegments", false)
    default:
      return state
  }
}

export default segmentsReducer
